import { Component, OnInit } from '@angular/core';
import { HttpService } from 'src/app/services/http.service';
import { UiServices } from 'src/app/services/ui-services';
import { WithDrawDetailsComponent } from '../../componentsAdmin/with-draw-details/with-draw-details.component';
import { WithdrawStatus } from 'src/app/types';

@Component({
  selector: 'app-wallet-cash-out',
  templateUrl: './wallet-cash-out.page.html',
  styleUrls: ['./wallet-cash-out.page.scss'],
})
export class WalletCashOutPage implements OnInit {
  public rols: any[] = [
    {
      id: 'Pendiente ',
      value: WithdrawStatus.Pendiente,
    },
    {
      id: 'Aprobado  ',
      value: WithdrawStatus.Aprobado,
    },
    {
      id: 'Rechazado ',
      value: WithdrawStatus.Rechazado,
    },
  ];
  public page: any = 1;
  public search = '';
  public columns = undefined;
  public isLoading = true;
  public rows: any[] = [];
  public totalPages: any = '';
  public status = '';
  public messages = {
    emptyMessage: 'No hay registros.',
  };

  constructor(private httpSv: HttpService, private uiSv: UiServices) {}

  async ngOnInit() {
    await this.getSearch();

    const column = [
      { name: 'ID', prop: 'id' },
      { name: 'Nombre', prop: 'name' },
      { name: 'Correo', prop: 'email' },
      { name: 'Estatus', prop: 'status' },
      { name: 'Acciones', prop: 'showMore' },
    ];

    this.columns = column;
  }

  async getSearch(ev?) {
    try {
      this.search = ev?.value || '';
      if (ev?.id !== undefined) {
        this.status = ev?.id;
      }
      this.isLoading = true;
      const res: any = await this.httpSv.itemIndex('withdrawalRequest', '', {
        name: this.search,
        pag: this.page,
        status: this.status,
      });
      this.totalPages = res.data.meta.last_page;
      const userData: any[] = res.data.data;
      this.rows = userData.map((item) => {
        return {
          id: item.id,
          name: item.user.name,
          email: item.user.email,
          status: item.status,
          showMore: 'Ver más',
        };
      });
      this.isLoading = false;
      return true;
    } catch (err) {
      console.error(err);
    }
  }

  async getClick(ev) {
    if (ev.type === 'click') {
      // const columnName = ev.column.name;
      const id = ev.row.id;
      this.showConfirmationModal(id);
    }
  }

  async showConfirmationModal(id: string) {
    const { data } = await this.uiSv.showModal(
      WithDrawDetailsComponent,
      { id },
      'withdraw'
    );
    if (data) {
      await this.getSearch();
    }
  }

  getRowClass(row) {
    setTimeout(() => {
      const elementsVer = document.querySelectorAll(`[title="Ver más"]`);
      elementsVer.forEach((node) => {
        node.classList.add('rolSpan');
      });
      // const elements = document.querySelectorAll(`[title="${row.rolId}"]`);
      // const elementsNoVer = document.querySelectorAll(`[title="No verificado"]`);
      // const elementsRecharge = document.querySelectorAll(`[title="Acción"]`);
      // elements.forEach(node => {
      //   node.classList.add('rolSpan');
      // });
      // elementsNoVer.forEach(node => {
      //   node.classList.add('rolSpan');
      // });
      // elementsRecharge.forEach(node => {
      //   node.classList.add('rolSpan');
      // });
    });
    return;
  }

  changePage(event) {
    this.page = event;
    this.getSearch();
  }
}
